import React from 'react'
import { QuestionFrame, TextFieldQuestion } from 'components/questions'


export const Q05 = () => {
  return (
    <QuestionFrame q={5}>
      <TextFieldQuestion
        num={1}
        content={'竣工図等において、建物敷地の基準点（GL=±0.00m）の標高（T.P.）は何mですか。\n(※ 竣工図等で確認できない場合は、入力手引書の方法により算定した高さを記載してください。)'}
        unitLabel='m'
        width={200}
        inputType='number'
      />

      <TextFieldQuestion
        num={2}
        content={'外部から建物内への水の侵入経路の高さ（問5①の高さと最も低い建物開口部の下端高さの差）は何ｍですか。 (※ ①の高さより下に開口部がある場合は、マイナス表記にしてください。)'}
        unitLabel='m'
        width={200}
        inputType='number'
      />

    </QuestionFrame>
  )
}
